import { gql } from '@apollo/client';

import { SubjectCollectionFragment } from '../fragments';

export const GetSubjectCollectionQuery = gql`
    query GetSubjectCollection($args: OLSubjectCollectionArgs) {
        getOLSubjectCollection(args: $args) @connection(key: "getOLSubjectCollection") {
            ...SubjectCollection
        }
    }
    ${SubjectCollectionFragment}
`;
